import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function CorrectQuiz({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g
        fill="none"
        fillRule="evenodd"
        className={theme.stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M.7 19.83C.608 30.49 9.172 39.206 19.83 39.3c10.659.093 19.375-8.471 19.47-19.13C39.392 9.51 30.828.794 20.17.7 9.511.608.795 9.172.7 19.83z" />
        <path
          className={cx(theme.fill, theme.quizFill, theme.secondFill)}
          d="M20 7.692l3.613 8.378 8.695 1.024-6.462 6.202 1.76 9.012L20 27.763l-7.606 4.545 1.76-9.012-6.462-6.202 8.695-1.024z"
        />
      </g>
    </svg>
  )
}

CorrectQuiz.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
